function Footer() {
    return(
        <footer>
            <p>Created at <a href="https://junocollege.com/" target="_blank" rel="noreferrer">Juno College</a> by <a href="http://www.lindacolumbus.ca" target="_blank" rel="noreferrer">Linda Columbus</a></p>
            <p></p>
        </footer>
    )
}

export default Footer;